import { render } from "./PaymentHistoryV2.vue?vue&type=template&id=59cd94b4&scoped=true"
import script from "./PaymentHistoryV2.vue?vue&type=script&lang=js"
export * from "./PaymentHistoryV2.vue?vue&type=script&lang=js"

import "./PaymentHistoryV2.vue?vue&type=style&index=0&id=59cd94b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cd94b4"]])

export default __exports__